<div id="card-{{ rubro.IdRubro }}" class="card mt-2 bg-light">
  <div class="card-body">
    <div class="row">
      <div class="col">
        <h5 class="card-title">{{ rubro.Nombre }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ rubro.Descripcion }}</h6>
      </div>
      <div class="col text-right">
        <button 
          *ngIf="isShowAcciones()" type="button"
          class="btn btn-sm btn-secondary mr-1"
          (click)="clickAcciones(rubro)"
        >
          <i class="fa fa-plus"></i> Acciones
        </button>

        <button
          *ngIf="isShowObservaciones() && rubro.IdEstatus == 5 && [3].includes(userSesion.Roles[0].IdRol) && !isCumpleRubro(rubro.Calificacion)"
          type="button"
          class="btn btn-sm btn-secondary mr-1"
          (click)="clickObservaciones(rubro)"
        >
          <i class="fa fa-pen"></i> Observaciones
        </button>

        <button
          *ngIf="rubro.IdEstatus == 3 && rubro.IdRolValidacion == userSesion.Roles[0].IdRol"
          type="button"
          class="btn btn-sm btn-success mr-1"
          (click)="clickValidarRubro(rubro.IdRubro)"
          [disabled]="disableValidaRubro"
        >
          <i class="fa fa-check"></i> Validar
        </button>

        <button
          *ngIf="rubro.IdEstatus == 3 && rubro.IdRolValidacion == userSesion.Roles[0].IdRol"
          type="button"
          class="btn btn-sm btn-danger mr-1"
          (click)="clickRechazarRubro(rubro.IdRubro)"
        >
          <i class="fa fa-times"></i> Rechazar
        </button>

        <button
          type="button"
          class="btn btn-sm btn-primary mr-1"
          (click)="clickShowMotivo(rubro.IdRubro)"
          *ngIf="rubro.IdEstatus == 4"
        >
          <i class="fa fa-list"></i> Motivo de rechazo
        </button>

        <button
          class="btn btn-sm btn-warning text-white"
          (click)="historial(rubro.IdRubro)"
        >
          <i class="fa fa-list"></i> Historial
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h6>Calificación: <span>{{ rubro.Calificacion }}</span></h6>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h6>
          Estatus:
          <span [ngStyle]="{ 'color': (rubro.IdEstatus == 1 ? defaultColor : rubro.Estatus.Color) }">
            {{ rubro.Estatus.Descripcion }}
          </span>
        </h6>
      </div>
    </div>
    <div class="row" *ngIf="rubro.IdEstatus == 3">
      <div class="col">
        <h6>
            Rol pendiente de validar:
            <span [ngStyle]="{ 'color': (rubro.IdEstatus == 1 ? defaultColor : rubro.Estatus.Color) }">
              {{ rubro.RolValidacion }}
            </span>
        </h6>
      </div>
    </div>
    <app-pregunta [global]="global" [pregunta]="pregunta" *ngFor="let pregunta of rubro.Preguntas"></app-pregunta>
  </div>
</div>
